import Components from "../components";
import UAParser from "ua-parser-js";

// Initial bot list compiled from various sources online and updated from:
// https://raw.githubusercontent.com/monperrus/crawler-user-agents/master/crawler-user-agents.json
// (downcase, dedup and ensure proper RegExp string escaping when updating)
const BOTS =
  "googlebot|adsbot-google|mediapartners-google|bingbot|slurp|java|wget|curl|commons-httpclient|python-urllib|libwww|httpunit|nutch|go-http-client|phpcrawl|msnbot|jyxobot|fast-webcrawler|fast enterprise crawler|biglotron|teoma|convera|seekbot|gigabot|gigablast|exabot|ngbot|ia_archiver|gingercrawler|webmon |httrack|webcrawler|grub\\.org|usinenouvellecrawler|antibot|netresearchserver|speedy|fluffy|bibnum\\.bnf|findlink|msrbot|panscient|yacybot|aisearchbot|ioi|ips-agent|tagoobot|mj12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|linguee bot|voyager|cyberpatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|adidxbot|blekkobot|ezooms|mail\\.ru_bot|discobot|heritrix|findthatfile|europarchive\\.org|nerdbynature\\.bot|sistrix crawler|ahrefsbot|aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|retrevopageanalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|duckduckbot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net\\.com\\.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler\\.com|siteexplorer\\.info|elisabot|proximic|changedetection|blexbot|arabot|wesee:search|niki-bot|crystalsemanticsbot|rogerbot|360spider|psbot|interfaxscanbot|lipperhey seo service|cc metadata scaper|g00g1e\\.net|grapeshotcrawler|urlappendbot|brainobot|fr-crawler|binlar|simplecrawler|livelapbot|twitterbot|cxensebot|smtbot|bnf\\.fr_bot|a6-indexer|admantx|facebot|orangebot|memorybot|advbot|megaindex|semanticscholarbot|ltx71|nerdybot|xovibot|bubing|qwantify|archive\\.org_bot|applebot|tweetmemebot|crawler4j|findxbot|semrushbot|yoozbot|lipperhey|y!j-asr|domain re-animator bot|addthis|screaming frog seo spider|metauri|scrapy|openhosebot|capsulechecker|collection@infegy\\.com|istellabot|deusu\\/|betabot|cliqzbot\\/|mojeekbot\\/|netestate ne crawler|safesearch microdata crawler|gluten free crawler\\/|sonic|sysomos|trove|deadlinkchecker|slack-imgproxy|embedly|rankactivelinkbot|iskanie|safednsbot|skypeuripreview|veoozbot|slackbot|redditbot|datagnionbot|google-adwords-instant|adbeat_bot|scanbot|whatsapp|baidu|bingpreview|duckduck|yandex|aolbuild|twikle|paperlibot|unwindfetchor|pingdom";

const BROWSER_ICONS = {
  ie: "fa-internet-explorer",
  edge: "fa-edge",
  firefox: "fa-firefox",
  safari: "fa-safari",
  opera: "fa-opera",
  chrome: "fa-chrome",
  chromium: "fa-chrome",
};

// Other possible OS values: ['meego', 'symbian', 'blackberry', 'bada', 'freebsd', 'bsd', 'solaris', 'trim', 'qnx',  'playstation', 'wii', 'xbox', 'unix']
const OS_ICONS = {
  android: "fa-android",
  mac: "fa-apple",
  ios: "fa-apple",
  windows: "fa-windows",
  chromium: "fa-chromium",
  kubuntu: "fa-linux",
  xubuntu: "fa-linux",
  lubuntu: "fa-linux",
  ubuntu: "fa-linux",
  gentoo: "fa-linux",
  fedora: "fa-linux",
  mandriva: "fa-linux",
  redhat: "fa-linux",
  suse: "fa-linux",
  debian: "fa-linux",
  slackware: "fa-linux",
  arch: "fa-linux",
  linux: "fa-linux",
  pclinuxos: "fa-linux",
  centos: "fa-linux",
  webos: "fa-linux",
  gnu: "fa-linux",
};

const DEVICE_ICONS = {
  pc: "fa-desktop",
  mobile: "fa-mobile",
  tablet: "fa-tablet",
  smarttv: "fa-television",
  console: "fa-square",
};

function getIcon(collection, name, fallback) {
  const matchingKey = Object.keys(collection).find((key) =>
    new RegExp(key, "i").test(name),
  );
  return matchingKey ? collection[matchingKey] : fallback;
}

class UserAgentComponent extends Components.Base {
  initialize() {
    const uaString = this.$el.html();
    const parser = new UAParser();
    parser.setUA(uaString);

    const browser = parser.getBrowser();
    const os = parser.getOS();
    const device = parser.getDevice();
    const isBot = new RegExp(BOTS, "i").test(uaString);

    this.$el.html("");

    if (isBot) {
      this.$el.append(
        '<i class="fa fa-cogs" aria-hidden="true" title="We think this user may be a bot."></i>',
      );
    }
    if (browser.name) {
      this.$el.append(this.browserIcon(browser.name));
    }
    if (os.name) {
      this.$el.append(this.osIcon(os.name));
    }

    if (browser.name) {
      this.$el.append(this.deviceIcon(device.type || "PC"));
      this.$el.append(
        `<span class="handsfree" data-action="click->fault-handsfree#valSel" data-path="user_agent.browser.name" data-value="${browser.name}">${browser.name}</span>`,
      );

      if (browser.version) {
        this.$el.append(
          ` <span class="handsfree" data-action="click->fault-handsfree#valSel" data-path="user_agent.browser.version" data-value="${browser.version}">${browser.version}</span>`,
        );
      }

      const showUserAgent = $.cookie("showUserAgent") === "true";

      const hiddenUA = $(
        '<div id="hidden-ua" class="user-agent-string collapse"></div>',
      );
      hiddenUA.html(uaString);
      if (showUserAgent) {
        hiddenUA.addClass("show");
      }

      const showLink = $(
        '<a href="#" class="btn btn-sm btn-secondary float-sm-end toggle-user-agent" data-bs-toggle="collapse">Show User Agent</a>',
      );
      showLink.html(showUserAgent ? "Hide User Agent" : "Show User Agent");
      showLink.attr("href", `#${$(hiddenUA).attr("id")}`);

      this.$el.append(showLink);
      this.$el.append('<br clear="all">');
      this.$el.append(hiddenUA);
    } else {
      this.$el.append(uaString);
    }
  }

  browserIcon(name) {
    const icon = getIcon(BROWSER_ICONS, name, "fa-globe");
    return `<i class="fa fa-3 ${icon}" aria-hidden="true" title="Browser: ${name}"></i>`;
  }

  osIcon(name) {
    const icon = getIcon(OS_ICONS, name, "fa-check-circle");
    return `<i class="fa fa-3 ${icon}" aria-hidden="true" title="Operating System: ${name}"></i>`;
  }

  deviceIcon(name) {
    const icon = getIcon(DEVICE_ICONS, name, "fa-laptop");
    return `<i class="fa fa-3 ${icon}" aria-hidden="true" title="Device: ${name}"></i>`;
  }

  bind() {
    return this.on("click", "a.toggle-user-agent", (e) =>
      this.saveSelection(e),
    );
  }

  saveSelection(e) {
    const active = !$(e.target.getAttribute("href")).hasClass("show");
    $(e.target).html(active ? "Hide User Agent" : "Show User Agent");
    $.cookie("showUserAgent", active, { expires: 365, path: "/" });
  }
}

Components.collection.register({
  selector: ".c-user-agent",
  klass: UserAgentComponent,
});
